<template>
    <line-chart id="lineChart"
                :data="localeData"
                :title="title"
                :x-axis="xAxis"
                :enable-resize="enableResize">
    </line-chart>
</template>

<script>
import LineChart from "@/components/LayoutMaps/openLayers/stuff/LineChart";
import stackedMixin from "@/components/LayoutMaps/openLayers/stuff/stackedMixin";

export default {
    name: "StackedLineChart",
    components: {LineChart},
    mixins: [stackedMixin],
    props: {
        data: Object,
        title: {
            type: String,
            default: ""
        },
        xAxis: {
            type: Array,
            default: () => []
        },
        enableResize: String,//vertical/horizontal/both
    },
    computed: {
        $_exportData() {
            //拼装dataset
            let tempObject = {};
            for (let item in this.localeData) {
                let temp = [];
                for (let i = 0; i < this.xAxis.length; i++) {
                    temp.push([this.xAxis[i], this.localeData[item][i]]);
                }
                tempObject[item] = temp;
            }
            return tempObject;
        }
    },
    data() {
        return {
            localeData: this.data,
        }
    },
    methods: {
        $_stackIntoLocale(data = this.exportChartData) {
            if (data) {
                for (let item in data) {
                    if (Object.prototype.hasOwnProperty.call(this.localeData, item)) {
                        if (!confirm("包含重名数据集 " + item + "，是否覆盖？")) {
                            continue;
                        }
                    }
                    this.$set(this.localeData, item, data[item]);
                }
            }
        },
    }
}
</script>

<style scoped>

</style>